import { Container,Row,Col,Image,Button,Form} from 'react-bootstrap';
import HeaderB from '../../components/headerb/HeaderB'
import './Question.css'
import { Link } from 'react-router-dom';

export default function Question() {
  return (
    <>

<Container fluid > 
    <HeaderB /> 
</Container>

<Container>
    <Row className="justify-content-md-center">

        <Col xs={10} md={9} >

            <br/><br/><br/><br/><br/><br/>
      <Form.Select title='موضوع' size="lg">
        <option>موضوع</option>
      </Form.Select>
      <br />
      <Form.Select title='سوال کلی' size="lg">
        <option>سوال کلی</option>
      </Form.Select>
      <br />
      <Form.Select title='سوال جزئی' size="lg">
        <option>سوال جزئی</option>
      </Form.Select>
      </Col>

    <Row className="justify-content-md-center">
    <img className='square5' src="images/images (1).png" alt="images"></img>
      <Col xs={9} md={8} center className="d-grid gap-2">
      <br/><br/><br/>
      <Link className='linkBtn' to='/'>ثبت</Link>
      </Col>
      
    </Row>

    </Row>
</Container>

    </>
  );
}

